export default __webpack_public_path__ + "static/epica-lite-1-a56512f791da0de30c644f4589f7eed5.jpg";